import { render, staticRenderFns } from "./Cmdbconfig.vue?vue&type=template&id=ca65b580&"
import script from "./Cmdbconfig.vue?vue&type=script&lang=js&"
export * from "./Cmdbconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports